import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    padding: ['52px 33px 90px', '90px 0px 164px'],
  },
};
